import client from "lib/api/client"

export const getNews = (count?: number) => {
  const query = count ? `?count=${count}` : ""; // 引数があればクエリを生成
  return client.get(`/news${query}`);
};

export const getNewsLabels = () => {
  return client.get("/news_label_masters");
};

export const getNewsDetail = (urlHash: string) => {
  return client.get(`/news/${urlHash}`);
};
